import { styled } from '@mui/material/styles';
import LinkMui from '@mui/material/Link';
export var Link = styled(LinkMui)(function (_a) {
    var theme = _a.theme, color = _a.color;
    var linkPalette = theme.palette.link || {};
    var resolvedColor = color || linkPalette.main || '#404041';
    return {
        color: resolvedColor,
        textDecorationColor: resolvedColor,
        cursor: 'pointer',
        textDecoration: 'underline',
        fontWeight: '500',
        ':hover': {
            color: linkPalette.hover || '#1A1919',
            textDecorationColor: linkPalette.hover || '#1A1919',
            transition: 'color 0.5s',
        },
        ':active': {
            color: linkPalette.active || '#A1A1A1',
            textDecorationColor: linkPalette.active || '#A1A1A1',
        },
        ':focus-visible': {
            outline: 'none',
            color: linkPalette.hover || '#1A1919',
            textDecorationColor: linkPalette.hover || '#1A1919',
        },
    };
});
